export default __webpack_public_path__ + "static/media/7.d84c7930.png";